module.exports = __webpack_public_path__ + "static/img/3_1.18b41091.jpg";